import { Box } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import NewFilters from '../../../components/NewFilters/NewFilters'
import { requestFilters } from '../../../helpers/getRequestsFilters'
import { isAdmin, isDealer } from '../../../services/AccountService'
import checkboxStore from '../../../stores/CheckboxStore'
import NewPaginationStore from '../../../stores/NewPaginationStore'
import { getComp } from '../../../utils/utils/DI'
import { RequestReportType } from '../../NewReports/types/report.types'
import RequestsTableFilterStore from '../../RequestsManagement/components/NewRequestsTable/stores/RequestsTableFilterStore'
import { RequestTableParamsType } from '../../RequestsManagement/components/NewRequestsTable/types/new-requests-table.types'
import { useSingleReportFilters } from '../hooks/useSingleReportTableFilters'

interface SingleReportFiltersProps {
  reportId: number
  report: RequestReportType
}

export const singleReportPaginationStore = new NewPaginationStore(
  {} as RequestTableParamsType,
)
export const singleReportFiltersStore = new RequestsTableFilterStore()

const SingleReportTableFilters: FC<SingleReportFiltersProps> = ({
  reportId,
  report,
}) => {
  const { actionButtonProps, data, intl, onSearch, setChip } =
    useSingleReportFilters(reportId, report)

  return (
    <Box mb={1} pr={1} pl={1}>
      {/* @ts-ignore */}
      <NewFilters
        gray
        title={intl.formatMessage(
          {
            id: 'Найдено заявок {reports}',
            defaultMessage: 'Найдено заявок {reports}',
          },
          {
            reports: data?.totalSize ?? 0,
          },
        )}
        setChip={setChip}
        totalCollectionLength={data?.totalSize ?? 0}
        filtersStore={singleReportFiltersStore}
        filtersData={getFiltersData(intl)}
        onSearch={onSearch}
        filtersContainerHeight={'150px'}
        actionButtonProps={actionButtonProps}
        disableProgress={true}
        paginationStore={singleReportPaginationStore}
        checkboxStore={checkboxStore}
      />
    </Box>
  )
}
const getFiltersData = (intl: any) => {
  if (isAdmin()) return getAdminFiltersData(intl)
  else if (isDealer()) return getDealerFiltersData(intl)
}

const getAdminFiltersData = (intl: any) => [
  [
    requestFilters.dataCheckingStatus(
      intl,
      getComp('StatusesStore').getDataCheckingStatuses({
        dealerReportsFilters: false,
      }),
    ),
    [requestFilters.id(intl), requestFilters.phone(intl)],
    requestFilters.fullName(intl),
    requestFilters.address(intl),
    [requestFilters.from(intl), requestFilters.to(intl)],
  ],
  [
    [
      requestFilters.installedFrom(intl, null),
      requestFilters.installedTo(intl, null),
    ],
    requestFilters.categories(intl),
  ],
]

const getDealerFiltersData = (intl: any) => [
  [
    requestFilters.dataCheckingStatus(
      intl,
      getComp('StatusesStore').getDataCheckingStatuses({
        dealerReportsFilters: false,
      }),
    ),
    [requestFilters.id(intl), requestFilters.phone(intl)],
    requestFilters.fullName(intl),
    requestFilters.address(intl),
    [requestFilters.from(intl), requestFilters.to(intl)],
    [
      requestFilters.installedFrom(intl, null),
      requestFilters.installedTo(intl, null),
    ],
  ],
  [requestFilters.categories(intl)],
]

export default observer(SingleReportTableFilters)
